import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Consulting/Hero";
import DevelopServices from "../components/Consulting/DevelopServices";
import Process from "../components/Consulting/Process";
import Customers from "../components/Consulting/Customers";
import Success from "../components/Consulting/Success";
import ConsultingServices from "../components/Consulting/ConsultingServices";
import PageTitle from "../components/Consulting/PageTitle";


import '../assets/Webdevelopment.css';



const Consulting = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<ConsultingServices />
	    	<Process />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default Consulting;
